//the CSS for thios component are in the parent component

import { Link } from 'components/Atoms/Link'
import { usePriceDirection } from 'hooks/usePriceDirection'
import { usePriceFeed } from 'hooks/usePriceFeed'
import { useYoloModal } from 'lib/yoloModals/useYoloModal'

export const AssetRow = ({ assetInfo }) => {
  const { id, color } = assetInfo
  const { priceFeed } = usePriceFeed(id)
  const { direction } = usePriceDirection(priceFeed.price)

  const { updateModal } = useYoloModal()

  const onAssetClick = () => {
    const assetInfoModalObj = {
      show: true,
      id: 'assetInfo',
      props: {
        assetInfo: {
          id,
        },
      },
      backdropBlurred: false,
    }
    updateModal(assetInfoModalObj)
  }

  return (
    // <div className='table_row' onClick={onAssetClick}>
    <div className='table_row'>
      <div className='column stock_icon'>
        <div className='ai_asset_icon' style={{ background: color }}></div>
      </div>
      <div className='column stock_symbol'>
        <span className='no_link'>{id}</span>
        {/* <span >{id}</span> */}
      </div>
      <div className={`column stock_current_change ${direction}`}>
        <div className={`price_direction ${direction}`}></div>
        <span>{priceFeed.price}</span>
      </div>
    </div>
  )
}
